
export const MUNI_PURPOSES = [
    {label:'Agriculture', value:'holdUseOfProceeds=Agriculture'},
    {label:'Education', value:'holdUseOfProceeds=Education'},
    {label:'Government', value:'holdUseOfProceeds=Government'},
    {label:'Healthcare', value:'holdUseOfProceeds=Healthcare'},
    {label:'Housing', value:'holdUseOfProceeds=Housing'},
    {label:'Industrial', value:'holdUseOfProceeds=Industrial'},
    {label:'Recreation', value:'holdUseOfProceeds=Recreation'},
    {label:'Transportation', value:'holdUseOfProceeds=Transportation'},
    {label:'Utilities', value:'holdUseOfProceeds=Utilities'}
]


// WEBPACK FOOTER //
// ./src/twd/values/muni-purposes.js